import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import MultiSelectCheckbox from '@awp/components/Common/DropDown/Multiselect/MultiselectCheckbox';
import PropTypes from 'prop-types';

import { getDatasetDropdownOptions, selectMultiStationData } from '@stores/dataVisualizationSlice';

const MultiSelect = ({ withImages, setSelectedOptions, selectedOptions }) => {
  const data = useSelector(selectMultiStationData)?.DataVisualizationDTOs[0];

  const { optionsWithGroup, options } = getDatasetDropdownOptions(data, withImages);

  useEffect(() => {
    setSelectedOptions(options);
  }, [data]);

  function onChange(value) {
    setSelectedOptions(value);
  }

  return (
    <>
      <MultiSelectCheckbox
        options={optionsWithGroup || []}
        value={selectedOptions}
        //styles={selectStyles}
        onChange={onChange}
      />
    </>
  );
};

MultiSelect.propTypes = {
  withImages: PropTypes.bool.isRequired,
  setSelectedOptions: PropTypes.any.isRequired,
  selectedOptions: PropTypes.any.isRequired,
};

export default MultiSelect;
